import { Control } from "../Controls/Control";
import { ControlParams } from "../Controls/ControlInterfaces";

export class WrapPanel extends Control {
    constructor(params: ControlParams) {
        super(params);

        this.element.classList.add("wrap-panel");

        const components: HTMLCollection = this.element.children;

        this._drawComponents(components);
    }

    private _drawComponents(components: HTMLCollection): void {
        let component: HTMLElement;
        for (let i = 0; i < components.length; i++) {
            component = components[i] as HTMLElement;
            component.style.width = component.getAttribute("data-width") + "px";
            component.style.height = component.getAttribute("data-height") + "px";
        }
    }
}
